import { Fragment } from "react";
import {
  Grid,
  Button,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";
import { Visibility, Warning } from "@mui/icons-material";

const DuplicatedAlertList = ({ items, entityName, createNoteButton }) => {
  if (!items?.length) return null;

  return (
    <Grid item xs={6}>
      <Accordion
        sx={{
          "& .MuiCollapse-root.MuiCollapse-entered": {
            overflowY: "auto",
            maxHeight: 200,
          },
        }}>
        {/* =======================
            HEADER
        ======================= */}
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography
            sx={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
            }}>
            <Warning color="warning" sx={{ mr: 1 }} />
            ¡CUIDADO!
            <Typography
              component="span"
              sx={{ ml: 1, color: "text.secondary" }}>
              (Click para ver {entityName.toLowerCase()}s duplicados)
            </Typography>
          </Typography>
        </AccordionSummary>

        {/* =======================
            BODY
        ======================= */}
        <AccordionDetails>
          <Fragment>
            <Typography
              sx={{
                mb: "10px",
              }}>
              Por favor, utilice un único registro.
              {createNoteButton && (
                <>
                  {" "}
                  Unifíque las notas en un solo registro con la opción:{" "}
                  <Button
                    color="primary"
                    variant="outlined"
                    size="small"
                    sx={{ ml: 1 }}>
                    CREAR NOTA
                  </Button>
                </>
              )}
            </Typography>

            {items.map((item, index) => {
              const matchValue =
                item.match_type === "documento"
                  ? item?.nif
                  : item.match_type === "email"
                  ? item?.email
                  : "";

              return (
                <Alert key={item?.id ?? index} severity="info" sx={{ mb: 1 }}>
                  <Box>
                    <Typography
                      variant="span"
                      sx={{ textTransform: "capitalize" }}>
                      {entityName}
                    </Typography>{" "}
                    <Typography variant="span">duplicado con:</Typography>{" "}
                    <b>
                      {item.match_type}
                      {matchValue ? `: ${matchValue}` : ""}
                    </b>
                    <Button
                      size="small"
                      color="info"
                      variant="outlined"
                      sx={{ ml: 2 }}
                      component={NavLink}
                      startIcon={<Visibility />}
                      target="_blank"
                      to={`/${entityName}s/ver?id=${item?.id}`}>
                      Ver {entityName}
                    </Button>
                  </Box>
                </Alert>
              );
            })}
          </Fragment>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default DuplicatedAlertList;
